import styled from 'styled-components';

export const HeaderSidebarCorporateWrapper = styled.div`
  display: unset;
  .hsc-main-container {
    border-left: 1rem solid ${(props) => props.color};
    .hsc-links {
      display: grid;
      grid-template-areas: 'a a';
    }
  }
  @media (max-width: 991px) {
    margin: 0px;
  }
`;
